export default __webpack_public_path__ + "static/media/gutermann-white.65efd2a6.png";